<template>
  <v-row justify="center">
    <div>
      <div v-for="(question, index) in screen.questions" :key="question.id">
        <LessonTestSingleQuestion
          v-if="question.type === 'SingleChoiceQuestionExecution'"
          :index="index + startFrom"
          :question="question"
          :element-finished="elementFinished"
          @questionAnswered="singleChoiceQuestionAnswered"
        />
        <LessonTestMultipleQuestion
          v-else
          :index="index + startFrom"
          :question="question"
          :element-finished="elementFinished"
          @questionAnswered="multipleChoiceQuestionAnswered"
        />
      </div>
    </div>
  </v-row>
</template>

<script>
import LessonTestSingleQuestion from '@/components/course/element/lesson/lesson-test/LessonTestSingleQuestion.vue';
import LessonTestMultipleQuestion from '@/components/course/element/lesson/lesson-test/LessonTestMultipleQuestion.vue';

export default {
  components: {
    LessonTestSingleQuestion,
    LessonTestMultipleQuestion
  },
  props: {
    screen: {
      type: Object,
      required: true
    },
    elementFinished: {
      type: Boolean,
      required: true
    },
    screenIndex: {
      type: Number,
      required: true
    },
    screens: {
      type: Array,
      required: true
    }
  },
  computed: {
    startFrom() {
      let questionsCount = 0;

      for (let i = this.screenIndex - 1; i >= 0; i--) {
        if (this.screens[i].type === 'TestScreenExecution') {
          questionsCount += this.screens[i].questions.length;
        } else {
          break;
        }
      }

      return questionsCount;
    }
  },
  methods: {
    singleChoiceQuestionAnswered(ev) {
      this.$emit('questionAnswered', {
        type: 'SingleChoiceQuestionExecution',
        ...ev
      });
    },
    multipleChoiceQuestionAnswered(ev) {
      this.$emit('questionAnswered', {
        type: 'MultipleChoiceQuestionExecution',
        ...ev
      });
    }
  }
};
</script>
